module.exports = __webpack_public_path__ + "img/flow6.12cefb8d.png";